export default __webpack_public_path__ + "static/media/sass.7c4b9896.svg";